import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Circle, Plus, X, ListChecks } from "lucide-react";
import { api } from "../../lib/api";

const DEFAULT_STAGES = [
  "Brief y objetivos", "Planeación y presupuesto", "Producción y logística",
  "Convocatoria y difusión", "Ejecución del evento", "Seguimiento y reporte",
];

export default function ModuleStages({ moduleKey, item, onRefresh }) {
  const init = Array.isArray(item.etapas) && item.etapas.length
    ? item.etapas
    : DEFAULT_STAGES.map((n) => ({ nombre: n, done: false }));
  const [stages, setStages] = useState(init);
  const [nuevo, setNuevo] = useState("");
  const done = stages.filter((s) => s.done).length;
  const pct = stages.length ? Math.round((done / stages.length) * 100) : 0;

  const persist = async (arr) => {
    setStages(arr);
    try { await api.patch(`/mod/${moduleKey}/items/${item.id}`, { etapas: arr }); onRefresh?.(); }
    catch { toast.error("Error al guardar etapas"); }
  };
  const toggle = (i) => persist(stages.map((s, j) => (j === i ? { ...s, done: !s.done } : s)));
  const add = () => { if (!nuevo.trim()) return; persist([...stages, { nombre: nuevo.trim(), done: false }]); setNuevo(""); };
  const remove = (i) => persist(stages.filter((_, j) => j !== i));

  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-3" data-testid="module-stages">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 overline text-navy/40"><ListChecks className="w-3.5 h-3.5" /> Etapas del proceso</div>
        <span className="text-xs text-navy/50" data-testid="stages-progress">{done}/{stages.length} · {pct}%</span>
      </div>
      <div className="h-1.5 rounded-full bg-navy/10 overflow-hidden"><div className="h-full bg-gradient-violet transition-all" style={{ width: `${pct}%` }} /></div>
      <div className="space-y-1.5">
        {stages.map((s, i) => (
          <div key={i} className="flex items-center gap-2 group" data-testid={`stage-${i}`}>
            <button onClick={() => toggle(i)} className={s.done ? "text-emerald-600" : "text-navy/30 hover:text-violet"} data-testid={`stage-toggle-${i}`}>
              {s.done ? <CheckCircle2 className="w-5 h-5" /> : <Circle className="w-5 h-5" />}
            </button>
            <span className={`flex-1 text-sm ${s.done ? "line-through text-navy/40" : "text-navy/80"}`}>{s.nombre}</span>
            <button onClick={() => remove(i)} className="text-navy/20 hover:text-destructive opacity-0 group-hover:opacity-100"><X className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <input value={nuevo} onChange={(e) => setNuevo(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder="Añadir etapa…" data-testid="stage-new-input"
          className="flex-1 bg-white border border-dashed border-navy/20 rounded-lg px-3 py-2 outline-none focus:border-violet text-sm" />
        <button onClick={add} className="btn btn-primary" data-testid="stage-add-btn"><Plus className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
